module.exports = __webpack_public_path__ + "img/60.e915906d.jpg";